import React, { useEffect, useState, useMemo } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { configOrganizationSubmit } from "ServerAPI/serverAPI";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import editIcon from "../../assets/images/add-course/edit.svg";
import RefreshButton from "components/elements/refresh-button/RefreshButton";
import { useToast } from "context/toast-context/ToastProvider";
// import deleteIcon from "../../assets/images/add-course/delete.svg";
// import ConfirmationDialog from "components/Dialog/ConfirmationDialog";

const Department = ({
  allDepartments,
  setAllDepartments,
  fetchOrganisationDetails,
  allProcessess,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  // const [departmentIndex, setDepartmentIndex] = useState(null);
  const [cookies] = useCookies();
  const { showToast } = useToast();

  const [departmentData, setDepartmentData] = useState({
    incharge: "",
    email: "",
    phone: "",
    title: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDepartmentData((prev) => ({ ...prev, [name]: value }));
  };

  const filteredDepartments = allDepartments.filter((dept) =>
    String(dept.title || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const openAddModal = () => {
    setEditingIndex(null);
    setDepartmentData({ incharge: "", email: "", phone: "", title: "" });
    setShowModal(true);
  };

  const openEditModal = (index) => {
    const originalIndex = allDepartments.findIndex(
      (dept) => dept.title === filteredDepartments[index].title
    );
    setEditingIndex(originalIndex);
    setDepartmentData(filteredDepartments[index]);
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!departmentData.title) {
      alert("Department title is required!");
      return;
    } else if (!departmentData.email) {
      alert("Incharge mail is required!");
      return;
    } else if (!departmentData.incharge) {
      alert("Incharge name is required!");
      return;
    } else if (!departmentData.phone) {
      alert("Incharge mobile number is required!");
      return;
    }
    const newEntry = {
      ...departmentData,
      createdDate:
        editingIndex !== null
          ? allDepartments[editingIndex].createdDate
          : new Date().toISOString(),
    };

    let updatedDepartments;
    if (editingIndex !== null) {
      updatedDepartments = [...allDepartments];
      updatedDepartments[editingIndex] = newEntry;
    } else {
      updatedDepartments = [...allDepartments, newEntry];
    }

    // setAllDepartments(updatedDepartments);
    setIsSubmitting(true);

    const payload = {
      email: cookies.email,
      department: updatedDepartments,
      roleId: cookies.roleId,
      organizationId: String(cookies.organizationId),
      userId: cookies.userId,
      domain: allProcessess,
    };

    try {
      const response = await configOrganizationSubmit(payload);
      console.log("response_", response);

      if (response?.status === 200) {
        showToast("Department added", "success");
        fetchOrganisationDetails();
      } else {
        showToast(response?.message, "error");
      }
    } catch (error) {
      console.log("error_", error);

      showToast(error?.response?.data?.message, "error");
    } finally {
      setIsSubmitting(false);
      setShowModal(false);
    }
  };

  const handleRefresh = () => {
    fetchOrganisationDetails();
  };

  // const deleteDepartment = (index) => {
  //   setDepartmentIndex(index);
  //   setOpenConfirmationDialog(true);
  // };

  // const handleDeleteConfirm = () => {
  //   setAllDepartments((prev) => prev.filter((_, i) => i !== departmentIndex));
  //   setOpenConfirmationDialog(false);
  // };

  const columns = [
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>SN</span>
      ),
      accessorKey: "sn",
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Department</span>
      ),
      accessorKey: "title",
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>
          Incharge Name
        </span>
      ),
      accessorKey: "incharge",
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>
          Created Date
        </span>
      ),
      accessorKey: "createdDate",
      cell: ({ getValue }) =>
        getValue() ? new Date(getValue()).toLocaleDateString() : "-",
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Actions</span>
      ),
      accessorKey: "actions",
      cell: ({ row }) => (
        <>
          <img
            src={editIcon}
            className="cursor-pointer me-2"
            alt="editIcon"
            onClick={() => openEditModal(row.index)}
          />
          {/* <img src={deleteIcon} className="cursor-pointer" alt="deleteIcon" onClick={() => deleteDepartment(row.index)} /> */}
        </>
      ),
    },
  ];

  const data = useMemo(
    () =>
      filteredDepartments.map((dept, index) => ({
        sn: index + 1,
        title: dept.title || "-",
        incharge: dept.incharge || "-",
        createdDate: dept.createdDate || "-",
      })),
    [filteredDepartments]
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <TextField
          size="small"
          variant="outlined"
          placeholder="Search for department"
          InputProps={{ startAdornment: <SearchIcon /> }}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-2"
        />
        <div className="d-flex align-items-center gap-4">
          <RefreshButton handleRefresh={handleRefresh} title="Refresh Domain" />
          <Button variant="primary" onClick={openAddModal}>
            <AddIcon /> Add
          </Button>
        </div>
      </div>

      <TanstackTable
        columns={columns}
        data={data}
        pagination
        // className="border border-gray-300 divide-y divide-gray-300"
        // style={{ color: "black", border: "1px solid #ccc" }}
      />

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "rgba(34, 75, 153, 1)" }}>
            {editingIndex !== null ? "Edit Details" : "Add Details"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Department Name</Form.Label>
              <Form.Control
                name="title"
                value={departmentData.title}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Incharge Name</Form.Label>
              <Form.Control
                name="incharge"
                value={departmentData.incharge}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                name="email"
                value={departmentData.email}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                value={departmentData.phone}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            style={{
              backgroundColor: "transparent",
              color: "rgba(34, 75, 153, 1)",
            }}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isSubmitting}
          >
            {isSubmitting ? <Spinner size="sm" animation="border" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <ConfirmationDialog
        open={openConfirmationDialog}
        handleClose={() => setOpenConfirmationDialog(false)}
        handleConfirm={handleDeleteConfirm}
        message="Do you really want to delete this department?"
      /> */}
    </>
  );
};

export default Department;
